import { CRRender } from "@/components/crRender";
import "./style.css";
const TextBox = ({ title, text, className="", textBoxClassName="" }) => {
  return (
    <div className={`note-card ${className}`}>
      <div className={`text-box ${textBoxClassName}`}>
        <CRRender condition={title}>
          <h4 className="text-title">{title}</h4>
        </CRRender>
        <p className="text m-0">{text}</p>
      </div>
    </div>
  );
};

export default TextBox;
